import React, { Component } from 'react';
import { withRouter } from 'react-router'
import kindbody from 'assets/logos/kindbody.svg';
import './styles.css';
import '../responsive.css';

class Form extends Component {
  componentDidMount() {
    document.body.classList.add('form');
  }

  componentWillUnmount() {
    document.body.classList.remove('form');
  }

  render() {
    return (
      <div className="responsive__layout">
        <div className="form__header">
          <img src={kindbody} alt="kindbody" />
        </div>
        <div className="responsive__content">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default withRouter(Form);



// WEBPACK FOOTER //
// ./src/layouts/Form/Form.js